export const billingHistory = {
  fileWrap: {
    display: 'flex',
  },
  iconWrap: {
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid var(--neutral-200)',
    borderRadius: '8px',
    marginRight: '12px',
  },
  invoiceName: {},
  weight700: {
    fontWeight: 700,
  },
  amount: {
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: 1.75,
  },
  neutral300: {
    color: 'var(--neutral-300)',
  },
  statusWrap: (color: string) => ({
    color,
    position: 'relative',
    paddingRight: '10px',
    textAlign: 'right',
    '&::after': {
      content: '""',
      width: '5px',
      height: '5px',
      borderRadius: '50%',
      position: 'absolute',
      right: '0',
      top: '0',
      bottom: '0',
      margin: 'auto 0',
      backgroundColor: color,
    },
    '& .status': {
      lineHeight: '1',
    },
  }),
  optionsWrap: {
    display: 'flex',
    flexDirection: 'column',
  },
  tableTitle: {
    marginBottom: '0px',

    '@media (min-width: 1200px)': {
      marginBottom: '12px',
    },
  },
  tableCell: {
    padding: '7px 0 ',
  },
  smallText: {
    color: 'var(--neutral-500)',
    fontSize: '14px',
    lineHeight: '1.5',
  },
  percentage: {
    background: 'var(--neutral-50)',
    padding: '16px',
    marginY: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    border: '1px solid var(--neutral-100)',
    borderRadius: '8px',
    flexShrink: 0,
  },
  percentButton: {display: 'flex', gap: '24px', alignItems: 'center'},

  loader: {
    position: 'absolute',
    left: 'calc(50% - 25px)',
    top: '200px',
  },

  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: '16px',
    paddingTop: '8px',
    flexShrink: 0,

    '@media (max-width: 1199.98px)': {
      display: 'none',
    },
  },

  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0,
  },
};
